import { IconPhoneFilled } from "@tabler/icons-react";
import { useRef } from "react";
import ModalPop from "../../home/ModalPop";

export default function Quick() {
  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };
  return (
    <>
      <ModalPop popupRef={popupRef} closefnc={closefunc} />
      <ul className="lg:hidden fixed bottom-0 grid grid-cols-2 gap-2 w-full p-2 bg-white z-40">
        <li className="btn-11 relative w-full h-fit">
          <button
            className="flex justify-center items-center w-full h-full gap-1 border border-[#e1e1e1] bg-[#f9f9f9] py-2"
            type="button"
            onClick={() => (window.location.href = "tel:010-4321-9728")}
          >
            <IconPhoneFilled size={16} stroke={0} />
            <small>010.4321.9728</small>
          </button>
        </li>
        <li className="inq">
          <button
            className="flex justify-center items-center w-full h-full gap-1 bg-primary text-white py-2"
            type="button"
            onClick={() => openfunc()}
          >
            상세견적문의
          </button>
        </li>
      </ul>
    </>
  );
}
